module.exports = __webpack_public_path__ + "img/1.5e1ba053.png";